import { useEffect, useRef } from "react";
import ReactMarkdown from 'react-markdown';
import DotsSpinner from "../common/dots-spinner.jsx";
import TypingDotSpinner from "../common/typing-dot-spinner.jsx";
import MessageItem from "./message-item.jsx";
import { cn } from "../../lib/utils.js";

export function MessageList({
  messages,
  count,
  loading,
  setSkiableMessagesCount,
  messageListRef,
  customer,
  chatConfigurationStyle,
  aiReplyLoading,
  handleSendMessage,
  iframeHeight
}) {
  const newSlotFirstMessageRef = useRef(null);

  useEffect(() => {

    const messageList = messageListRef.current;

    // Scroll to the bottom initially
    if (messageList && messages?.length <= 20) {
      messageList.scrollTop = messageList.scrollHeight;
    }

    const handleScroll = async () => {
      if (messageList && messageList.scrollTop === 0 && messages.length < count) {
        await setSkiableMessagesCount(messages.length);
      }
    };
    messageList?.addEventListener("scroll", handleScroll);
    if (newSlotFirstMessageRef.current) {
      const firstMessage = newSlotFirstMessageRef.current;
      firstMessage.scrollIntoView({ block: "start", behavior: "instant" });
    }
    return () => messageList?.removeEventListener("scroll", handleScroll);
  }, [messages, count, setSkiableMessagesCount, newSlotFirstMessageRef, messageListRef]);


  return (
    <div className="w-full flex flex-col bg-white rounded-t-md">
      <div ref={messageListRef} className={`scrollbar-thin overflow-y-auto px-4`} style={{ height: iframeHeight ? iframeHeight : '65vh' }}>
        {loading && <div className="flex justify-center"><DotsSpinner /></div>}
        {/* INITIAL MESSAGE */}
        {chatConfigurationStyle?.initialMessages && messages?.length <= 20 && count <= 20 &&
          <div className={cn("flex items-start my-[20px] w-full")}>
            <div className='bg-muted w-[30px] h-[30px] rounded-full mr-2'>
              <img className='object-contain w-full h-full' src={`${process.env.REACT_APP_S3_BASE_URL}/${chatConfigurationStyle?.profile}`} alt="Bot Avatar" />
            </div>
        <div className="max-w-[80%] message-container relative">
        <span className="text-[14px] font-medium my-1.5 block">{chatConfigurationStyle?.displayName}</span>
          <span
            className="p-4 rounded-md ltr:rounded-tl-none rtl:rounded-tr-none text-[14px] block w-fit bg-accent"
          >
            <ReactMarkdown
              className="prose"
              components={{
                ol: ({ node, ...props }) => <ol style={{ listStyleType: 'decimal', paddingLeft: '1.5em' }} {...props} />,
                ul: ({ node, ...props }) => <ul style={{ listStyleType: 'disc', paddingLeft: '1.5em' }} {...props} />,
                // eslint-disable-next-line
                a: ({ node, ...props }) => <a style={{ textDecoration: 'underline' }} target="_blank" {...props} />,
                pre: ({ node, ...props }) => <pre style={{ backgroundColor: '#f0f0f0', padding: '1em', borderRadius: '4px', overflowX: 'auto' }} {...props} />,
              }}
            >{chatConfigurationStyle?.initialMessages}</ReactMarkdown>
          </span>
        </div>
      </div>
        }
        {messages?.map((message, index) => (
          <MessageItem
            keyIndex={index}
            message={message}
            isFirstInNewSlot={messages?.length >= 20 && index === 20}
            messages={messages}
            newSlotFirstMessageRef={newSlotFirstMessageRef}
            chatConfigurationStyle={chatConfigurationStyle}
            handleSendMessage={handleSendMessage}
          />
        ))}
        {aiReplyLoading && <div className="flex items-start my-4 w-full">
          <div className='bg-muted w-[32px] h-[32px] rounded-full mr-2'>
            <img className='object-contain w-full h-full' src={`${process.env.REACT_APP_S3_BASE_URL}/${chatConfigurationStyle?.profile}`} alt="Bot Avatar" />
          </div>
          <div className="max-w-[80%]">
            <span className="px-[8px] py-[12px] rounded-md ltr:rounded-tl-none rtl:rounded-tr-none text-sm block w-fit bg-accent">
              <TypingDotSpinner />
            </span>
          </div>
        </div>}
      </div>
    </div >
  )
}